export const RSE_LINKS: { [key: string]: string } = {
    'green-key': 'https://www.laclefverte.org/le-label/les-criteres-du-label-clef-verte/',
    'green-snowflake': 'https://www.flocon-vert.org/',
  };
  